import React from 'react'

export default function DownloadRoadiePage() {
  return (
    <>
      <div className="main-wrapper inner--page">
        <section className="login">
          <div className="container">
            <div className="row formcontain">
              <div className="outterFormContainer col-md-8 offset-md-2">
                <div className="login-content">
                  <div className="heading-text text-center">
                    <h3>Download Roadie Apps</h3>
                  </div>
                  <div className="row">
                    <div className="login-form col-md-6">
                      <form className="ml-5">
                        <p className="normalText">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.roadjockey.rider"
                            target="_blank"
                            className="primary-btn google"
                            rel="noreferrer"
                          >
                            Download Android App
                          </a>
                        </p>
                      </form>
                    </div>
                    <div className="login-form col-md-6">
                      <form className="ml-5">
                        <p className="normalText">
                          <a
                            href="https://apps.apple.com/us/app/road-jockey-rider/id1595611153"
                            target="_blank"
                            className="primary-btn google"
                            rel="noreferrer"
                          >
                            Download IOS App
                          </a>
                        </p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
